(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InsuranceCarrierSearch', InsuranceCarrierSearch);

    InsuranceCarrierSearch.$inject = ['$resource'];

    function InsuranceCarrierSearch($resource) {
        var resourceUrl =  'api/_search/insurance-carriers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
